import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

export default function gatheringsScript() {
  const gatheringFilterLinks = document.querySelectorAll('.c-invest-gatherings__filter a');
  const gatheringItems = document.querySelectorAll('.c-invest-gatherings__listing-item');
  const gatheringFilterSwiper = document.querySelector('.c-invest-gatherings__filter-swiper');

  if (gatheringFilterLinks && gatheringItems) {
    
    const swiperFilter = new Swiper(gatheringFilterSwiper, {
      modules: [Navigation],
      slidesPerView: 3,
      spaceBetween: 0,
      navigation: {
        nextEl: ".c-invest-gatherings__filter-next",
        prevEl: ".c-invest-gatherings__filter-prev",
      },
      breakpoints: {
        480: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 6,
        },
        992: {
          slidesPerView: 8,
        },
        1280: {
          slidesPerView: 8,
        },
      }
    });

    gatheringFilterLinks.forEach((filterLink) => {
      filterLink.addEventListener('click', (e) => {
        e.preventDefault();

        const year = filterLink.getAttribute('data-year');

        gatheringFilterLinks.forEach((link) => {
          link.classList.remove('active');
        });

        filterLink.classList.add('active');

        gatheringItems.forEach((item) => {
          if (item.getAttribute('data-year') === year) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });
      });
    });
  }
}
